import './globals'
import log from '../logger/log.js';
import {readonly, reactive, ref, watch} from 'vue';

import SockJS from 'sockjs-client';
import Order from './Order';
import Taxi from './Taxi';
import POI from '../do/POI';

function generateQuickGuid() {
    return Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
}

class Events
{
  constructor(events_data)
  {
    this.order = events_data.order;
    this.taxis = events_data.taxis;

    this.auth = null;
    this.url = null;
    this.sock = null;
    this.reconnect = true;
    this.errored = false;
    this.errored_last_mesg = null;
  }

  send(action_dict)
  {
    if (this.sock !== null && this.sock.readyState === SockJS.OPEN)
    {
      if(!action_dict.action_id)
      {
          action_dict.action_id = generateQuickGuid();
      }
      var json = JSON.stringify(action_dict);
      // log.d('protocol.send', json);
      this.sock.send(json + "\r\n\r\n");
      return true;
    }
    return false;
  };

  close()
  {
    if (this.sock)
    {
      this.sock.close();
      this.sock = null;
      this.reconnect = false;
      events_data.authenticated = false;
      events_data.errored = false;
      events_data.errored_last_mesg = null;
    }
    events_data.connected = false;
  };

  set_auth(auth)
  {
    this.auth = auth;
  }

  set_url(url)
  {
    this.url = url.replace(/\/+$/g, '');
  }

  connect()
  {
    this.close();
    this.order.from_track({});
    for (const prop in this.taxis) {
        if (this.taxis.hasOwnProperty(prop)) {
            delete this.taxis[prop];
        }
    }
    this.reconnect = true;
    this.sock = new SockJS(this.url);
    this.sock.onopen = this.onopen.bind(this);
    this.sock.onmessage = this.onmessage.bind(this);
    this.sock.onclose = this.onclose.bind(this);
  }

  onopen()
  {
    //log.d('sock.open');
    events_data.connected = true;
    let action_dict = {};
    action_dict.action = "LOGIN";
    action_dict.user_agent = navigator.userAgent || "";
    if ("order_short_id" in this.auth)
    {
        action_dict.order_short_id = this.auth.order_short_id;
        action_dict.secret = this.auth.secret;
        action_dict.user_agent = navigator.userAgent || "";
    }
    this.send(action_dict);
  }

  prepare_resp(action_dict)
  {
    var resp_dict = {};
    resp_dict.action = action_dict.action;
    if(action_dict.action_id)
    {
      resp_dict.action_id = action_dict.action_id;
    }
    resp_dict.status = "ERR";
    resp_dict.status_mesg = "UNKNOWN"; 
    return resp_dict;
  };

  send_order_cancel()
  {
    let action_dict = {};
    action_dict.action = "ORDER_CANCEL";
    this.send(action_dict);
  }

  onmessage(e)
  {
    //log.d('sock.message', e);
    //log.d('sock.message', e.data.length);
    if (e.data.trim() !== "")
    {
        this.parse(e.data);
    }
  }

  onclose()
  {
    //log.d('sock.onclose', this);
    events_data.connected = false;
    if (this.reconnect)
    {
      //log.d("reconnect");
      setTimeout(this.connect.bind(this)
        , 5000);
      //log.d('sock.close reconnect');
      this.close();
    }
  };

  parse(packet)
  {
    // log.d("protocol.parse", packet);
    let packet_dict = JSON.parse(packet);
    let event = packet_dict.action;
    let resp_dict = this.prepare_resp(packet_dict);
    if (event === "PING")
    {
      resp_dict.status = "OK";
      resp_dict.status_mesg = "OK";
      resp_dict.action = "PING";
      this.send(resp_dict);
      return;
    }

    if (event === "ORDER_UPDATE")
    {
      if(packet_dict.order) {
        this.order.from_track(packet_dict.order);
      }
      this.order.taxis_data = packet_dict.taxis_data;
      resp_dict.status = "OK";
      resp_dict.status_mesg = "OK";
      this.send(resp_dict);
      if(this.order.state === "A" || this.order.state === "M")
      {
        this.reconnect = false;
        this.close();
      }
      // log.d("ORDER EVENTS", this.order)
    }
    
    if (event === "TAXI_STATE_UPDATE")
    {
      const call_number = packet_dict.taxi.call_number;
      if (packet_dict.taxi.client === true) {
        if (!this.order.finished_taxis?.includes(call_number)) {
          this.order.finished_taxis.push(call_number);
        }
      }
      if (this.taxis[call_number]) {
        Object.assign(this.taxis[call_number], packet_dict.taxi);
        this.taxis[call_number].taxi_poi.lat = packet_dict.taxi.lat;
        this.taxis[call_number].taxi_poi.lng = packet_dict.taxi.lng;
      } else {
        const new_taxi = new Taxi(packet_dict.taxi);
        this.taxis[call_number] = new_taxi;
        const new_poi = new POI();
        new_poi.lat = packet_dict.taxi.lat;
        new_poi.lng = packet_dict.taxi.lng;
        this.taxis[call_number].taxi_poi = new_poi;
      }
      resp_dict.status = "OK";
      resp_dict.status_mesg = "OK";
      this.send(resp_dict);
    }

    if (event === "LOGIN")
    {
      if (packet_dict.error || packet_dict.status === 'ERR')
      {
        log.e("Events LOGIN ERROR", packet_dict.error_data);
        this.reconnect = false;
        events_data.errored = true;
        events_data.errored_last_mesg = packet_dict.status_mesg;
        return;
      }
      log.d("Events LOGIN OK" , packet_dict.vars);
      this.reconnect = true;
      events_data.authenticated = true;
      return;
    }
  }
}

const events_data = reactive({
  order: new Order(),
  taxis: {},
  connected: false,
  disconnected_ui: false,
  authenticated: false,
  errored: false,
  errored_last_mesg: null,
});

let disconnect_timer = null
watch(
    () => events_data.connected,
    (connected) =>
    {
        if (connected)
        {
            if (disconnect_timer)
            {
                clearTimeout(disconnect_timer)
                disconnect_timer = null
            }
            events_data.disconnected_ui = false
        } else
        {
            if (disconnect_timer)
            {
                clearTimeout(disconnect_timer)
            }
            disconnect_timer = setTimeout(() =>
            {
                events_data.disconnected_ui = true
                disconnect_timer = null
            }, 8000)
        }
    }
)

const events_data_ro = readonly(events_data);
const events = new Events(events_data);

const useTrack = function()
{
  return {
    events_data: events_data_ro,
    events
  };
}

export { useTrack };